export interface ScrollItem {
  left: number
  width: number
}

export type ScrollDirection = 'left' | 'right'

const PAIR_SIZE = 2
const EDGE_TOLERANCE = 4

export const getPairScrollTarget = (
  items: ScrollItem[],
  scrollLeft: number,
  direction: ScrollDirection
) => {
  if (items.length === 0) return 0

  const origin = items[0].left
  const firstVisible = items.findIndex(
    (item) => item.left - origin + item.width > scrollLeft + EDGE_TOLERANCE
  )
  const current = firstVisible === -1 ? items.length - 1 : firstVisible
  const target =
    direction === 'right'
      ? Math.min(current + PAIR_SIZE, items.length - 1)
      : Math.max(current - PAIR_SIZE, 0)

  return items[target].left - origin
}
